export enum StructureType {
  Branch = 1,
  Club = 11,
  District = 2,
}